module.exports = __webpack_public_path__ + "img/837001107_4.6f6b269a.jpg";